'use client';

import clsx from 'clsx';
import { useRef } from 'react';
import CheckBoxIcon from '../Icon/CheckCheckboxIcon';
import styles from './FormCheckbox.module.css';
import config from 'config-base';
import { CheckboxProps } from './types';

const Checkbox = ({
  checkboxMainContainerClasses,
  checkboxContainerClassName,
  checkboxControllerClassName,
  checkboxLabelClassName,
  label,
  id,
  disabled,
  value,
  name,
  labelClick,
  onChange,
  clickOnLabel,
  clickOnLabelCallback,
}: CheckboxProps) => {
  const checkboxRef = useRef<HTMLInputElement>(null);
  const checkboxControllerStyles: string = clsx(
    styles.checkboxControler,
    { [styles.checkboxControlerChecked]: value },
    { [styles.checkboxControlerDisabled]: disabled },
    styles.checkboxControlerTransition,
    checkboxControllerClassName,
  );

  return (
    <div className={clsx(styles.checkboxMainContainer, checkboxMainContainerClasses)}>
      <label className={clsx(styles.checkboxContainer, checkboxContainerClassName)}>
        <input
          type="checkbox"
          name={name}
          ref={checkboxRef}
          id={id}
          data-testid={`checkbox-${id}`}
          className={styles.checkboxInput}
          aria-labelledby={`checkbox-${id}`}
          aria-label={`checkbox-${id}`}
          disabled={disabled}
          checked={value}
          onChange={onChange}
        />
        <span className={checkboxControllerStyles}>
          {value && (
            <CheckBoxIcon
              className={clsx(styles.checkboxIcon, 'checkboxIcon', {
                [styles.checkboxIconDisabled]: disabled,
              })}
            />
          )}
        </span>
      </label>
      <span
        className={clsx(checkboxLabelClassName, styles.checkboxLabel, {
          [styles.checkboxLabelDisabled]: disabled,
          [styles.checkboxLabelAGD]: config.brandCode !== '0',
          [styles.checkboxLabelCheckedAGD]: config.brandCode !== '0' && value,
        })}
        data-testid={`checkbox-label-${id}`}
        onClick={() => {
          if (labelClick) {
            checkboxRef.current?.click();
          }
          if (clickOnLabel && clickOnLabelCallback) {
            clickOnLabelCallback();
          }
        }}
      >
        {label}
      </span>
    </div>
  );
};

export default Checkbox;
